import { withStyles } from '@/components/Buttons/Core/withStyles';
import { BaseButton } from '@/components/Buttons/Core/BaseButton';

export const SuccessButton = withStyles(BaseButton, {
    light: 'lime.600',
    dark: 'lime.600',
    
    textStyle: {
        light: 'white',
        dark: 'dark',
    }
});
